var lib_core    = require("lib-core");
var lib_geometry      = require("lib-geometry");

var TooltipHelper = function(el, title, stateMachine, scope, config) {

    $(el).on("mouseenter", function(event){
        var bb = this.getBoundingClientRect();
        var tooltipArrowPositionSpacing = 2;
        var direction = (config && config.direction) || 'n';
        var posX, posY;
        
        ////////////////////////////
        // [element box]          //
        //  ------(x,y)-------    //
        // |                  |   //   
        // |                  |   //   
        // (x,y)             (x,y)//
        // |                  |   //
        // |                  |   //
        //  ------(x,y)-------    //
        ////////////////////////////
        
        switch(direction) {
            case 'w':
                posX = $(this).offset().left + bb.width + tooltipArrowPositionSpacing;
                posY = $(this).offset().top + bb.height / 2;
            break;

            case 'e':
                posX = $(this).offset().left - tooltipArrowPositionSpacing;
                posY = $(this).offset().top + bb.height / 2;
            break;

            case 'n':
                posX = $(this).offset().left + bb.width / 2;
                posY = $(this).offset().top + bb.height + tooltipArrowPositionSpacing;
            break;

            case 's':
                posX = $(this).offset().left + bb.width / 2;
                posY = $(this).offset().top - tooltipArrowPositionSpacing;
            break;
        }
        

        // # TODO: ADD DIRECTION SUPPORT

        // if((window.innerWidth - bb.right) < 300){
        //     if(bb.left > 300){
        //         direction = "e";
        //     }else{
        //         if((window.innerHeight - bb.bottom) < 300){
        //             direction = "s";
        //         }else{
        //             direction = "n";
        //         }
        //     }
        // }

        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TOOLTIP_SHOW)
            .data('position', new lib_geometry.Coord(posX, posY) )
            .data('direction', direction )
            .data('title', title )
            .scope(scope);

        stateMachine.handle(cEvent);
    });

    $(el).on("mouseleave", function(event){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TOOLTIP_HIDE).scope(scope);
        stateMachine.handle(cEvent);
    });
};

module.exports = TooltipHelper;

